const c = ["#ffe0e0", "#ffbdbd", "#ee7c7c", "#d74f4f", "#a50303"], f = [
  c[0],
  c[1],
  "#ffabab",
  c[2],
  c[3],
  c[4]
], _ = [
  c[0],
  c[1],
  "#ffabab",
  c[2],
  c[3],
  "#c63434",
  c[4]
], b = [
  c[0],
  "#ffcccc",
  c[1],
  "#ffabab",
  c[2],
  c[3],
  "#c63434",
  c[4]
], A = [
  c[0],
  "#ffcccc",
  c[1],
  "#ffabab",
  "#f99393",
  c[2],
  c[3],
  "#c63434",
  c[4]
], E = [
  c[0],
  "#ffcccc",
  c[1],
  "#ffabab",
  "#f99393",
  c[2],
  "#e16565",
  c[3],
  "#c63434",
  c[4]
];
export {
  E as HEAT_MAP_RED_10,
  c as HEAT_MAP_RED_5,
  f as HEAT_MAP_RED_6,
  _ as HEAT_MAP_RED_7,
  b as HEAT_MAP_RED_8,
  A as HEAT_MAP_RED_9
};
//# sourceMappingURL=index.es5573.js.map
